import React from "react";

interface ModalWithImageEmailBackgroundProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  buttons?: React.ReactNode;
}

export default function ModalWithImageEmailBackground({ open, onClose, children, buttons }: ModalWithImageEmailBackgroundProps) {

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/30"
      onClick={onClose}
    >
      <div
        className="relative flex flex-col w-[715px] h-[620px] rounded-lg overflow-hidden bg-cover bg-center"
        style={{
          backgroundImage: "url('/images/ModalImg.png')",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Centered content area */}
        <div className="flex-1 flex items-center justify-start w-full">
          {children}
        </div>
        {/* Bottom area for buttons */}
        <div className="bg-white flex items-center justify-end gap-4 p-4">
          {buttons}
        </div>
      </div>
    </div>
  );
};